export class ParametroImpositivoEncabezado { 
    provinciaId: string;
    provinciaNombre: string;
    provinciaCodigo: string;
    fechaActualizacion: string;
}